<form [formGroup]="form" (ngSubmit)="onSubmit()" class="recording-segment-form">
  <mat-form-field class="recording-segment-form__field">
    <mat-label>
      {{ 'TRANS__FIELD__RECORDING_SEGMENT__START__SHORT' | translate }}
    </mat-label>

    <input
      matInput
      appTimecodeValueAccessor
      formControlName="start"
      [readonly]="inactive()"
    />
  </mat-form-field>

  <mat-form-field class="recording-segment-form__field">
    <mat-label>
      {{ 'TRANS__FIELD__RECORDING_SEGMENT__END__SHORT' | translate }}
    </mat-label>

    <input
      matInput
      appTimecodeValueAccessor
      formControlName="end"
      [readonly]="inactive()"
    />
  </mat-form-field>

  <mat-form-field class="recording-segment-form__field recording-segment-form__field--span">
    <mat-label>
      {{ 'TRANS__FIELD__RECORDING_SEGMENT__REMARKS' | translate }}
    </mat-label>

    <input
      matInput
      formControlName="remarks"
      [readonly]="inactive()"
    />
  </mat-form-field>

  @if ((startCtrl.touched && startCtrl.invalid) ||
  (endCtrl.touched && endCtrl.invalid) ||
  ((startCtrl.touched || endCtrl.touched) && form.hasError('validateTimecodeInterval'))) {
    <mat-error class="recording-segment-form__field--span">
      {{ getControlError('start') || getControlError('end') }}
    </mat-error>
  }

  <div class="recording-segment-form__actions recording-segment-form__field--span">
    <button
      matButton="filled"
      type="submit"
      [disabled]="inactive() || !form.dirty || form.invalid"
    >
      {{ 'TRANS__FIELD__RECORDING_SEGMENT__CREATE' | translate }}
    </button>

    <button
      mat-button
      type="button"
      [disabled]="inactive()"
      (click)="onClear()"
    >
      {{ 'TRANS__FIELD__RECORDING_SEGMENT__CLEAR' | translate }}
    </button>
  </div>
</form>
